import React from 'react';
import { SocialSigninButton } from 'spa/member/components/SocialSigninButton';
import CWSignupButton from '../../../../../../../assets/images/signup/crowdworks.png'
import GoogleSignupButton from '../../../../../../../assets/images/signup/google.png'
import GithubSignupButton from '../../../../../../../assets/images/signup/github.png'
import { SocialSigninButtonProps } from 'spa/member/components/SocialSigninButton/types';

export const StyledSocialSignupModal: React.FC = () => {
  const CWProps: SocialSigninButtonProps = {
    serviceName: 'crowdworks',
    src: CWSignupButton,
    alt: 'Sign up with CrowdWorks',
  }
  const GoogleProps: SocialSigninButtonProps = {
    serviceName: 'google',
    src: GoogleSignupButton,
    alt: 'Sign up with Google',
  }
  const GithubProps: SocialSigninButtonProps = {
    serviceName: 'github',
    src: GithubSignupButton,
    alt: 'Sign up with Github',
  }
  return (
    <div className="bg-member-gray-10 rounded-M p-M" style={{ boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.08)' }}>
      <div className="grid grid-cols-2">
        <SocialSigninButton {...CWProps} />
      </div>
      <div className="grid grid-cols-2">
        <SocialSigninButton {...GoogleProps} />
        <SocialSigninButton {...GithubProps} />
      </div>
    </div>
  );
};
